const CDN_URL = process.env.REACT_APP_CDN_URL;

const home = {
  title: "Every Wall a Canvas",
  description: "Your Vision, Brought to Life",
  heroVideo: `${CDN_URL}/videos/buy_a_wallpen.mp4`,

  // What is Vertical Printing Section
  whatIsVerticalPrinting: {
    title: "What is Vertical Printing?",
    description:
      "A cutting-edge technology that prints directly on walls, glass, metal, and wood—no vinyl or canvas needed. It delivers vibrant, high-resolution designs for custom art, branding, and interior enhancement.",
  },

  // Swiper.js Carousel Images for Vertical Printing Examples
  carouselImages: [
    `${CDN_URL}/gallery/plaster-16.jpg`,
    `${CDN_URL}/gallery/plaster-34.jpg`,
    `${CDN_URL}/gallery/concrete-3.jpg`,
    `${CDN_URL}/gallery/glass-3.jpg`,
    `${CDN_URL}/gallery/DSC00052.JPG`,
  ],

  // wallPen Features Section
  features: [
    "100% Handmade in Germany – Built with world-class quality.",
    "5-Minute Setup – No complicated assembly, print instantly.",
    "Variable Height (Up to 13ft) – Prints on walls of all sizes.",
    "Low Maintenance – Reliable, industrial-grade German engineering.",
    "UV Ink, Cured Instantly – Crisp, vibrant, and long-lasting prints.",
    "Power Drive & Steering – Precise movement for perfect prints.",
  ],
  wallPenImage: `${CDN_URL}/home/wallpen_e2.png`,

  // Training Section
  training: {
    title: "Training",
    description:
      "Success starts with the right training and support. At SurfacePix, we’re committed to equipping you with everything you need to master vertical printing. From hands-on equipment training to personalized business coaching, we provide the tools and resources to help you confidently operate your wallPen® E2. But we don’t stop there—our expert guidance extends to branding, marketing, and sales strategies, ensuring your business is set up for long-term success.",
    businessSupport: [
      {
        title: "Company Formation",
        description:
          "We help you write and manage your company formation documents.",
        icon: "DocumentTextIcon",
      },
      {
        title: "Equipment Training",
        description:
          "We teach you everything you need to know to confidently operate your machine.",
        icon: "CogIcon",
      },
      {
        title: "Logo Design & Branding",
        description:
          "We help you design your logo and branding to jump-start your company.",
        icon: "SparklesIcon",
      },
      {
        title: "SEO & PPC Marketing",
        description:
          "We help you navigate the complexities of ROI in digital marketing.",
        icon: "ChartBarIcon",
      },
      {
        title: "Social Media",
        description:
          "We help you implement social media strategies to generate buzz and get leads.",
        icon: "ShareIcon",
      },
      {
        title: "Sales & CRM Integration",
        description:
          "We help you turn your leads into sales with CRM tools and sales coaching.",
        icon: "CurrencyDollarIcon",
      },
    ],
    image: `${CDN_URL}/images/training/training.jpg`,
  },

  partner: {
    title: "Partner",
    description:
      "At SurfacePix, we believe in building partnerships, not just providing tools. From the moment you join us, you’re part of a network dedicated to your growth and success. Together, we’ll elevate your wall printing business—whether it’s through innovative solutions, expert support, or helping you stand out in a competitive market. With SurfacePix by your side, you’re never just running a business; you’re creating a legacy.",
    notablePrints: [
      { name: "Shipping Facilities", icon: "TruckIcon" },
      { name: "Shopping Districts", icon: "ShoppingBagIcon" },
      { name: "Gyms", icon: "AcademicCapIcon" },
      { name: "Software Companies", icon: "CpuChipIcon" },
      { name: "AirBnbs", icon: "HomeIcon" },
      { name: "Medical Offices", icon: "HeartIcon" },
    ],
    features: [
      "Easy Setup – Quick and intuitive assembly process.",
      "White Underlay – Vivid and accurate colors on any surface.",
      "Any Surface – Glass, brick, steel, wood, or drywall.",
      "Durable Ink – Scratch-resistant and water-resistant.",
    ],
    businessGrowth: {
      title: "Grow Your Business",
      description:
        "We help you build a website you love that matches your budget, acquire clients, manage finances, and run your business successfully.",
    },
  },

  // Start Your Business Process Timeline
  processSteps: [
    { title: "Machine Purchase", description: "Get your wallPen machine." },
    { title: "Machine Training", description: "Learn to use it effectively." },
    { title: "Brand Guidance", description: "Create your identity." },
    { title: "Marketing Campaigns", description: "Attract local clients." },
    { title: "Website Creation", description: "Showcase your work online." },
    { title: "Ongoing Support", description: "We’ll be with you every step." },
  ],
  processVideo: `https://www.youtube.com/watch?v=HxDrcg0Oh2k`,

  accomplishments: [
    { number: "50+", title: "Machines Sold" },
    { number: "10K+", title: "Print Jobs Completed" },
    { number: "3+", title: "Years of Experience" },
    { number: "5+", title: "Partners Nationwide" },
  ],

  // Testimonials Section
  testimonials: [
    {
      quote: `“SurfacePix has been instrumental in transforming our wall printing business. The precision and efficiency of the WallPen allow us to create stunning, high-quality prints with ease. Their attention to detail in training, hands-on learning, and ongoing support make the experience truly unique. It’s not just another business, it feels like being part of a group of friends who genuinely have your back.

A special thanks to their Sales Manager, "Domus" without his guidance and support, we wouldn’t have been able to take the next step for our business. The owners are real people who truly care. Doug was amazing, he took time out of his own schedule to personally train and help me, ensuring we had everything we needed to succeed. They have always been just a call or message away, ready to support us at every turn.

If you're looking to elevate your business with professional wall printing solutions, SurfacePix is the perfect partner!”`,
      name: "David Paez",
      company: "SD Rebel Prints",
    },
    {
      quote: `“I had an outstanding experience with Surfacepix when purchasing my Wallpen printer. From the very beginning, their team went above and beyond to ensure I felt confident in my investment. They took the time to show me various locations where they had completed projects, allowing me to see the quality and versatility of the printer firsthand.

Beyond that, their customer service has been exceptional—always quick to respond, helpful, and professional. Whether it was answering my questions or providing support, they have consistently delivered top-notch service.

I would like to give special recognition to their sales manager, Domus. His expertise and dedication were instrumental in guiding me through the purchasing process. Domus took the time to understand my specific needs and provided tailored solutions, making the entire experience seamless and enjoyable. His commitment to customer satisfaction truly sets Surfacepix apart.”`,
      name: "Ben Whitfill",
      company: "5th Wall Printing",
    },
  ],
};

export default home;
